import { render, staticRenderFns } from "./CampaignPromotions.vue?vue&type=template&id=301fe1a8&scoped=true"
import script from "./CampaignPromotions.vue?vue&type=script&lang=js"
export * from "./CampaignPromotions.vue?vue&type=script&lang=js"
import style0 from "./CampaignPromotions.vue?vue&type=style&index=0&id=301fe1a8&prod&lang=scss&scoped=true"
import style1 from "./CampaignPromotions.vue?vue&type=style&index=1&id=301fe1a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301fe1a8",
  null
  
)

export default component.exports